import { Link } from "react-router-dom";
import Layout from "../components/layout/Layout";
import { Button } from "../components/ui/button";
import { Search, Home } from "lucide-react";

export default function NotFoundPage() {
  return (
    <Layout>
      <div className="max-w-lg mx-auto px-4 py-24 text-center">
        <h1 className="text-6xl font-bold text-slate-900 mb-2" data-testid="not-found-title">404</h1>
        <p className="text-lg text-slate-600 mb-8">
          Page not found. The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild>
            <Link to="/" className="inline-flex items-center gap-2">
              <Home className="h-4 w-4" />
              Back to Home
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/products" className="inline-flex items-center gap-2">
              <Search className="h-4 w-4" />
              Browse Products
            </Link>
          </Button>
        </div>
      </div>
    </Layout>
  );
}
